import React, { useState, useEffect } from 'react'
import AvailabilityDataTable from 'components/AvailabilityDataTable'

const SupplierAvailabilityDataTable = ({supplierId, setCallback = () => {}}) => {
  const [availabilities, setAvailabilities] = useState([])
  const [bookings, setBookings] = useState([])
  if (!supplierId) {
    return null
  }

  useEffect(() => {
    fetch(`/rest/v2/supplier/${supplierId}/availability`, { credentials: 'same-origin' }) 
      .then((response) => response.json())
      .then((availability) => setAvailabilities(availability.sort((a, b) => (
        a.startDate > b.startDate ? 1 : -1
      )))) 
      .catch((error) => toastr.error(error))
  
    fetch(`/rest/v2/supplier/${supplierId}/booking`, { credentials: 'same-origin' }) 
      .then((response) => response.json())
      .then((bookings) => setBookings(bookings.sort((a, b) => (
        a.startDate > b.startDate ? 1 : -1
      )))) 
      .catch((error) => toastr.error(error))
  }, [supplierId])

  const onSave = (prevEvent, nextEvent) => {
    let promise
    const body = JSON.stringify(nextEvent)

    if (prevEvent && 'uid' in prevEvent) {
      promise = fetch(`/rest/v2/supplier/${supplierId}/${prevEvent?.bookingDetails ? 'booking' : 'availability'}/${prevEvent.uid}`, { method: 'PUT', body, credentials: 'same-origin' }) 
    } else {
      promise = fetch(`/rest/v2/supplier/${supplierId}/${prevEvent?.bookingDetails ? 'booking' : 'availability'}`, { method: 'POST', body, credentials: 'same-origin' }) 
    }

    promise
      .then((response) => {
        if (response.status === 406) {
          const start = new Date();
          start.setUTCSeconds(nextEvent.dateStart);

          const end = new Date();
          end.setUTCSeconds(nextEvent.dateEnd);

          throw new Error(`Unavailability already requested from ${start.toLocaleDateString("en-GB")} to ${end.toLocaleDateString("en-GB")  } with message \"${nextEvent.message}\"`);
        }

        return response.json()
      })
      .then((data) => {
        if (data.errors) {
          if (prevEvent?.bookingDetails) {
            if (confirm("There were the following errors: \r\n\u2022 " + data.errors + "\r\n\r\nWould you like to create it anyways?")) {
              nextEvent.skipValidation = true;
              onSave(prevEvent, nextEvent)
            }
          } else {
            return toastr.error(data.errors)
          }
        }

        if (availabilities.find((availability) => availability.uid == data.uid)) { //Edit availability
          setAvailabilities(availabilities.map((availability) => {
            if (availability.uid == data.uid) {
              return data
            } else {
              return availability
            }
          }))
        } else { // New availability
          setAvailabilities([...availabilities, data])
        }
      })
      .catch((error) => toastr.error(error))
  }

  const onDelete = (availabilityId) => {
    fetch(`/rest/v2/supplier/${supplierId}/availability/${availabilityId}`, { method: 'DELETE', credentials: 'same-origin' }) 
      .then(() => setAvailabilities((availability) => availability.filter(({ uid }) => uid !== availabilityId)))
      .catch((error) => toastr.error(error))
  }

  const bookingAction = (action, bookingId, internalAvailabilities, message = '') => {
    const body = JSON.stringify({
      [action] : 1,
      message: message
    })

    fetch(`/rest/v2/supplier/${supplierId}/booking/${bookingId}`, { method: 'PUT', body, credentials: 'same-origin' })
      .then((response) => response.json())
      .then((json) => {
        setBookings([])
        setAvailabilities(internalAvailabilities.map((event) => {
          if ('bookingDetails' in event && event.bookingDetails.uid == json.uid) {
            event.bookingDetails = json
            return event
          }else if (!event.uid || event.uid == json.uid) {
            return json
          } else {
            return event
          }
        }))
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <div className='mt-2'>
      <AvailabilityDataTable
        bookingAction={(action, bookingId, internalAvailabilities, message) => bookingAction(action, bookingId, internalAvailabilities, message)}
        availabilities={availabilities}
        bookings={bookings}
        onSave={(prevEvent, nextEvent) => onSave(prevEvent, nextEvent)}
        onDelete={(availabilityId) => onDelete(availabilityId)}
        setCallback={setCallback}
        includeBookingRequest
        includeAvailabilityRequest
      />
    </div>
  )
}

export default SupplierAvailabilityDataTable
